/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_TitleInputs */



/**
* | output |
* | --- |
* | "Your practice conversations are ready" |
*
* @param {Onboarding_Pilot_Ready_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_title = /** @type {((inputs?: Onboarding_Pilot_Ready_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je oefengesprekken staan klaar")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos entretiens d’entraînement sont prêts")
	return /** @type {LocalizedString} */ ("Your practice conversations are ready")
});